import { store } from '@betacrew/jars-flux'
export const componentKey = "FORMS/RECONCILIATION/LISTING";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        updatePaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },
        setPayerDropdownOptions: (state, action) => {
            state.payerDropdownOptions = action.payload;
        },
        setTaxYearDropdownOptions: (state, action) => {
            state.taxYearDropdownOptions = action.payload;
        },
        setReconciliationStateDropdownOptions: (state, action) => {
            state.reconciliationStateDropdownOptions = action.payload;
        },
        setReconciliationFormsListRecords: (state, action) => {
            state.reconciliationFormsListRecords = action.payload;
        },
        setIsSelectedFormsCombinationAllowed: (state, action) => {
            state.isSelectedFormsCombinationAllowed = action.payload;
        },
    }, 
    initialReducerState: {
        loadingState: false,
        paginationState: {
            pageNumber: 1,
            pageSize: 10,
            skip: 0,
            sorts: [],
            total: 10,
        },
        payerDropdownOptions: [],
        taxYearDropdownOptions: [],
        reconciliationStateDropdownOptions: [],
        reconciliationFormsListRecords: [],
        isSelectedFormsCombinationAllowed: false,
    }
});
export const {
    setLoadingState,
    updatePaginationState,
    setPayerDropdownOptions,
    setTaxYearDropdownOptions,
    setReconciliationStateDropdownOptions,
    setReconciliationFormsListRecords,
    setIsSelectedFormsCombinationAllowed,
} = actions;